import React from 'react';
import Footer from '../Footer/Footer';
import Head from '../Head/Head';
import Nasa from './Nasa';
import './Temperature.css';

const Temperature = () => {
    const data = require('./Nasa.json')

    return (
        <div className='bg'>
            <Head />
            <div >
                
                <br/>
                <Nasa id="temp" />
                <Footer />
            </div>

        </div>
    );
};

export default Temperature;